import { __assign, __awaiter, __generator } from "tslib";
import { PluginType } from '@amplitude/analytics-types';
import { VERSION } from '../version';
export var context = function () {
    var library = "amplitude-ma-ts/".concat(VERSION);
    return {
        name: 'context',
        type: PluginType.ENRICHMENT,
        setup: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, undefined];
        }); }); },
        execute: function (context) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, (__assign(__assign({}, context), { library: library }))];
            });
        }); },
    };
};
//# sourceMappingURL=context.js.map